webpackJsonp([144251824217401],{

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/madhur-profile.dfbc77a4.png";

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mayur-profile.e2622151.png";

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heroContainer":"src-components-hero----hero-module---heroContainer---2Zbur","hero":"src-components-hero----hero-module---hero---2fD2W","title":"src-components-hero----hero-module---title---2HkC3","heroBody":"src-components-hero----hero-module---heroBody---2UeDT","blue":"src-components-hero----hero-module---blue---3pdK9","gradient":"src-components-hero----hero-module---gradient---3QZxo","green":"src-components-hero----hero-module---green---3oEPp","red":"src-components-hero----hero-module---red---3xEqe","yellow":"src-components-hero----hero-module---yellow---9eaP9","purple":"src-components-hero----hero-module---purple---38Mn9"};

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cardModule = __webpack_require__(60);
	
	var _cardModule2 = _interopRequireDefault(_cardModule);
	
	var _heroModule = __webpack_require__(151);
	
	var _heroModule2 = _interopRequireDefault(_heroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-extraneous-dependencies */
	
	/* eslint-disable import/no-extraneous-dependencies */
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: '' + _heroModule2.default.heroContainer },
	    _react2.default.createElement(
	      'div',
	      { className: _heroModule2.default.hero + ' ' + _heroModule2.default[props.color] + ' ' + (props.gradient ? _heroModule2.default.gradient : '') },
	      _react2.default.createElement(
	        'div',
	        { className: _heroModule2.default.heroBody },
	        _react2.default.createElement(
	          'h1',
	          { className: _heroModule2.default.title },
	          props.children
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'subtitle' },
	          props.subtitle
	        )
	      )
	    )
	  );
	};
	
	Hero.propTypes = {
	  subtitle: _propTypes2.default.string,
	  children: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string,
	  gradient: _propTypes2.default.bool
	};
	
	Hero.defaultProps = {
	  subtitle: '',
	  color: 'primary',
	  gradient: false
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"aboutContainer":"src-pageComponents-about----about-module---aboutContainer---16hO_","content":"src-pageComponents-about----about-module---content---8t7b9","detailsContainer":"src-pageComponents-about----about-module---detailsContainer---3XlUL","profilePic":"src-pageComponents-about----about-module---profilePic---2yU3t","altProfile":"src-pageComponents-about----about-module---altProfile---3vEiz","aboutFace":"src-pageComponents-about----about-module---aboutFace---3jMjd"};

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mayurProfile = __webpack_require__(344);
	
	var _mayurProfile2 = _interopRequireDefault(_mayurProfile);
	
	var _madhurProfile = __webpack_require__(343);
	
	var _madhurProfile2 = _interopRequireDefault(_madhurProfile);
	
	var _cardModule = __webpack_require__(60);
	
	var _cardModule2 = _interopRequireDefault(_cardModule);
	
	var _aboutModule = __webpack_require__(409);
	
	var _aboutModule2 = _interopRequireDefault(_aboutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-extraneous-dependencies */
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: _aboutModule2.default.aboutContainer },
	    _react2.default.createElement(
	      'div',
	      { className: _aboutModule2.default.detailsContainer },
	      _react2.default.createElement(
	        'div',
	        { className: _aboutModule2.default.profilePic },
	        _react2.default.createElement('img', { src: _madhurProfile2.default, alt: 'Madhur\'s Profile' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _aboutModule2.default.content },
	        _react2.default.createElement(
	          'h3',
	          null,
	          '"When brothers agree, no fortress is as strong as their common life."'
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          '~Antisthenes'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _aboutModule2.default.profilePic + ' ' + _aboutModule2.default.altProfile },
	        _react2.default.createElement('img', { src: _mayurProfile2.default, alt: 'Mayur\'s Profile' })
	      )
	    )
	  );
	}; /* eslint-disable import/no-extraneous-dependencies */
	

	module.exports = exports['default'];

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(200);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _mayurProfile = __webpack_require__(344);
	
	var _mayurProfile2 = _interopRequireDefault(_mayurProfile);
	
	var _madhurProfile = __webpack_require__(343);
	
	var _madhurProfile2 = _interopRequireDefault(_madhurProfile);
	
	var _hero = __webpack_require__(111);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _about = __webpack_require__(355);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _cardModule = __webpack_require__(60);
	
	var _cardModule2 = _interopRequireDefault(_cardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return [_react2.default.createElement(_reactHelmet2.default, { key: 'aboutHelmet', title: 'YesWeAreTwins' }), _react2.default.createElement(
	    _hero2.default,
	    { color: 'green', gradient: true, key: 'aboutHero' },
	    'About us'
	  ), _react2.default.createElement(_about2.default, { key: 'aboutDetails' })];
	};
	/* eslint-enable import/no-extraneous-dependencies */
	/* eslint-disable import/no-extraneous-dependencies */
	

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-6cb6bc2bb5ebd098b287.js